type Open<T extends string> = T | (string & {})

export const AUTH_SESSION_HEADER = 'X-Ap-Auth-Session'
export const AUTH_SESSIONS_PATH = '/portal/consumers/auth/sessions'
export const AUTH_SESSION_HANDOFF_PATH = '/portal/consumers/auth/session-token/login'

export type AuthSessionFactor = Open<'EMAIL_CODE'>

export type KnownAuthSessionNextStep =
  | { type: 'IDENTIFY'; factors: AuthSessionFactor[] }
  | { type: 'SIGN_UP' }
  | { type: 'REDIRECT'; reason: Open<'CONSUMER_REGION' | 'CASH_APP_LOGIN'>; url: string | null }
  | { type: 'BLOCKED'; reason: Open<'UNSUPPORTED_MERCHANT_TRADING_COUNTRY' | 'CONSUMER_REGION' | 'UNSUPPORTED_FLOW_REGION' | 'REDIRECT_LIMIT'> }
  | { type: 'ACCOUNT_UNAVAILABLE'; reason: Open<'RECOVERY_REQUIRED' | 'ACCOUNT_POLICY' | 'ACCOUNT_LOCKED' | 'ACCOUNT_CLOSED'> }
  | { type: 'COMPLETE'; handoff: { url: string; method: 'POST' } }

export type AuthSessionNextStep = KnownAuthSessionNextStep | { type: string & {}; reason?: string | null }

export interface CreateAuthSessionRequest {
  context: { kind: 'CHECKOUT'; checkoutToken: string; locale: string }
  device: { credential: null }
}

export interface CreateAuthSessionResponse {
  session: { sessionRef: string; sessionToken: string; state: Open<'ANONYMOUS'> }
  nextStep: AuthSessionNextStep
}

export interface CreatedAuthSession {
  sessionRef: string
  nextStep: AuthSessionNextStep
}

export interface OpenEmailChallengeRequest {
  factor: 'EMAIL_CODE'
  identifier: { kind: 'EMAIL'; value: string }
}

export interface AuthSessionChallenge {
  challengeRef: string
  factor: AuthSessionFactor
  attemptsRemaining: number
  codeLength: number
  destinationHint: string | null
}

export interface OpenEmailChallengeResponse {
  challenge: AuthSessionChallenge
  delivery: { state: Open<'QUEUED'> }
}

export interface CodeAttemptRequest {
  factor: 'EMAIL_CODE'
  code: string
}

export interface CodeAttemptResponse {
  attempt?: { outcome: Open<'ACCEPTED' | 'REJECTED'> } | null
  challenge?: Pick<AuthSessionChallenge, 'attemptsRemaining'> | null
  nextStep?: AuthSessionNextStep | null
}

export interface AuthSessionHandoffResponse {
  status: Open<'success'>
  user: { id: number; name: string; requires2fa: boolean; shouldAllowEmail: boolean; promotePersistentLogin: boolean }
}
